import { FC } from 'react';
import ReactPasswordStrength from 'react-password-strength/dist/universal';

import { useTranslation } from '../../../utils/i18n';

interface Props {
  value: string;
  onChange: (value: string) => void;
  // Overrides spread into the wrapped library's inputProps.
  placeholder?: string;
  autoComplete?: string;
}

const PasswordWithStrengthIndicator: FC<Props> = ({
  value = '',
  onChange: setValue = () => {},
  ...props
}) => {
  const { t } = useTranslation('common');
  // FIXME: Find an alternative to this library. The defaultValue prop is just
  // the initial value and doesn't make it a controlled component.
  return (
    <ReactPasswordStrength
      className="field__input"
      minLength={10}
      minScore={4}
      tooShortWord={t('registration.user_details.password.too_short')}
      scoreWords={[
        t('registration.user_details.password.weak'),
        t('registration.user_details.password.okay'),
        t('registration.user_details.password.good'),
        t('registration.user_details.password.strong'),
        t('registration.user_details.password.stronger'),
      ]}
      changeCallback={({ password }: { password: string }) =>
        setValue(password)
      }
      defaultValue={value}
      inputProps={{
        name: 'password',
        autoComplete: 'off',
        className: 'form-control',
        placeholder: t('registration.user_details.fields.password.label'),
        ...props,
      }}
    />
  );
};

export default PasswordWithStrengthIndicator;
